import Repository from "./Repository";

export default {
  racks(payload) {
    return Repository.post("rack", payload);
  },
  property(payload) {
    return Repository.post("property", payload);
  },
  banks(payload) {
    return Repository.post("bank_managekaro", payload);
  },
  orders(payload) {
    return Repository.post("orders", payload);
  },
  store(payload) {
    return Repository.post("store", payload);
  },
  datebook(payload) {
    return Repository.post("datebook", payload);
  },
  units(payload) {
    return Repository.post("category", payload);
  },
  email(payload) {
    return Repository.post("email", payload);
  },
  voucher(payload) {
    return Repository.post("voucher", payload);
  },
  bank(payload) {
    return Repository.post("bank", payload);
  },
  notification(payload) {
    return Repository.post("notifications", payload);
  },
  template(payload) {
    return Repository.post("template", payload);
  },
  companies(payload) {
    return Repository.post("companies", payload);
  },
  vehicle(payload) {
    return Repository.post("vehicles", payload);
  },
  sales(payload) {
    return Repository.post("sales", payload);
  },
  fastcash(payload) {
    return Repository.post("fast_cash", payload);
  },
  user(payload) {
    return Repository.post("users", payload);
  },
  company(payload) {
    return Repository.post("users", payload);
  },
  incentive(payload) {
    return Repository.post("incentive", payload);
  },
  ledger(payload) {
    return Repository.post("ledgers", payload);
  },
  salary(payload) {
    return Repository.post("salary", payload);
  },
  unit(payload) {
    return Repository.post("category", payload);
  },
  category(payload) {
    return Repository.post("category", payload);
  },
  vendor(payload) {
    return Repository.post("vendors", payload);
  },
  warehouseNum(payload) {
    return Repository.post("warehouse_bills", payload);
  },
  warehouseBill(payload) {
    return Repository.post("warehouse_bills", payload);
  },
  bills(payload) {
    return Repository.post("bills", payload);
  },
  shops(payload) {
    return Repository.post("shops", payload);
  },
  payment(payload) {
    return Repository.post("new-payment", payload);
  },
  invoice(payload) {
    return Repository.post("invoice", payload);
  },
  purchases(payload) {
    return Repository.post("purchases", payload);
  },
  default(payload) {
    return Repository.post("", payload);
  },
};
